import Hong1Node from "./Hong1Node";
import {HongPrizeEntity} from "./LotteryGGLV2Prefab";
import O1HD from "../../../../../engines/gameEngine";
import Hong3Node from "./Hong3Node";

const {ccclass, property} = cc._decorator;

@ccclass
export default class Hong3ItemNode extends cc.Component {

    @property({type:cc.Label,displayName:"名称"})
    lbName : cc.Label = null;
    @property({type:cc.Label,displayName:"金额"})
    lbPrize : cc.Label = null;

    @property(cc.Node)
    judge1Node : cc.Node = null;
    @property(cc.Node)
    judge2Node : cc.Node = null;
    @property(cc.Node)
    ZjNode : cc.Node = null;

    flag1 : boolean = false;
    flag2 : boolean = false;

    private mParentScript : Hong3Node;
    private mHongDefine : HongPrizeEntity;
    private mId : string;
    private mCurrPrizeNum : number;

    onLoad () {
        O1HD.on("Hong3ItemNode.checkJudgeNode" , this.checkJudgeNode , this );

        O1HD.on("Hong3ItemNode.remove" , this.remove , this );
        O1HD.on("Hong3ItemNode.setEggPrize" , this.setEggPrize , this );
        O1HD.on("Hong3ItemNode.autoPrize" , this.autoPrize , this );

        O1HD.on("Hong3ItemNode.triggerFlagPrizeOpen" , this.triggerFlagPrizeOpen , this );
    }

    start () {

    }


    /**
     * 绑定数据
     */
    bindData( parentScript : Hong3Node , id : string , prizeNum : number ){
        this.mParentScript = parentScript;
        this.mId = id;
        this.mCurrPrizeNum = prizeNum;
    }


    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        if ( this.node.getBoundingBoxToWorld().contains( pos ) && this.mHongDefine == null ) {
            //如果包含这个世界坐标 切 奖项定义为空
            this.mHongDefine = this.mParentScript.mParentScript.getPrize();
            this._refreshData();
        }
        if ( this.judge1Node.getBoundingBoxToWorld().contains( pos ) ) {
            this.flag1 = true;
            this._checkFinish();
            return ;
        }
        if ( this.judge2Node.getBoundingBoxToWorld().contains( pos ) ) {
            this.flag2 = true;
            this._checkFinish();
            return;
        }
    }

    private hasOpenFlag : boolean = false;
    private _checkFinish(){
        if ( this.flag1 && this.flag2 && !this.hasOpenFlag ) {
            this.hasOpenFlag = true;
            this.openPrize();
        }
    }
    private mFlagPrizeOpenFlag : boolean = false;

    /**
     * 触发 prize
     * @param flagPrizeOpenFlag
     */
    triggerFlagPrizeOpen( flagPrizeOpenFlag : boolean ){
        this.mFlagPrizeOpenFlag = flagPrizeOpenFlag;
        // console.log("Hong3Item mFlagPrizeOpenFlag" , this.mFlagPrizeOpenFlag );
        this.openPrize();
    }


    /**
     *
     * @param flagPrizeOpenFlag
     */
    openPrize ( ){
        if ( this.hasOpenFlag && this.mFlagPrizeOpenFlag ) {
            // 开奖
            this.mParentScript.openPrize( this.mHongDefine , this.node );
            if ( this.mHongDefine.flag ) {
                this.ZjNode.active = true;
                this.ZjNode.opacity = 0;
                cc.tween( this.ZjNode )
                    .to( 3 , { opacity : 255 })
                    .call( ()=>{

                    }).start();
            }
        }
    }

    /**
     *
     * @private
     */
    _refreshData(){
        this.lbPrize.string = this.mHongDefine.name;
        if ( this.mHongDefine.flag ) {
            this.lbName.string = `${this.mCurrPrizeNum}`;
        }else{
            let randomNum = Math.floor( Math.random() * ( 100 ) );
            let endNum = randomNum == this.mCurrPrizeNum ? this.mCurrPrizeNum + 1 : randomNum;
            this.lbName.string = `${endNum}`;
        }
    }

    remove(){
        if ( this.node ) {
            this.node.removeFromParent();
            this.node.destroy();
        }
    }


    /**
     * 设置彩蛋  开奖内容
     */
    setEggPrize( id : string,  hongPrizeEntity : HongPrizeEntity ){
        if ( this.node && this.mId == id ) {
            this.mHongDefine = hongPrizeEntity;
            if ( this.mHongDefine ) {
                this._refreshData();
            }
        }
    }

    /**
     * 自动开奖
     */
    autoPrize(){
        if ( this.node && this.mHongDefine ) {
            O1HD.getServices().userSrv.setCoins( this.mHongDefine.prize , true , this.node );
            if ( this.mHongDefine.flag ) {
                this.ZjNode.active = true;
                this.ZjNode.opacity = 0;
                cc.tween( this.ZjNode )
                    .to( 2 , { opacity : 255 })
                    .call( ()=>{
                    }).start();
            }
        }
    }
}
